import { GET_BY_ID, GET_BY_ID_LIST } from '@inpart-io/devtools-vue';
import { DataType } from '@inpart-io/padme-iap';
import { type DefaultCategory, type IPrivateLeadBoard } from '@inpart-io/padme-iap';
import { type GetterTree } from 'vuex';

import type { IPrivateLeadBoardState } from './types';

export const GET_DEFAULT_BOARD = 'getDefaultBoard';
export const GET_DEFAULT_BOARD_LIST = 'getDefaultBoardList';
export const GET_DEFAULT_BOARDS_PARTIALS = 'getDefaultBoardsPartial';

export const getters: GetterTree<IPrivateLeadBoardState, unknown> = {
    [GET_DEFAULT_BOARD]: (_state: IPrivateLeadBoardState, _getters) => {
        return (defaultViewCategory: DefaultCategory, targetType: string = DataType.Lead): IPrivateLeadBoard => {
            const id = _state.defaultBoards.get(targetType)?.[defaultViewCategory];
            if (id !== undefined) {
                return _getters[GET_BY_ID](id);
            }
            return null;
        };
    },
    [GET_DEFAULT_BOARD_LIST]: (_state: IPrivateLeadBoardState, _getters) => {
        return (defaultViewCategoryList: DefaultCategory[], targetType: string = DataType.Lead): IPrivateLeadBoard[] => {
            const idList: number[] = [];
            for (const category of defaultViewCategoryList) {
                const id = _state.defaultBoards.get(targetType)?.[category];
                if (id !== undefined) {
                    idList.push(id);
                }
            }
            if (idList.length > 0) {
                return _getters[GET_BY_ID_LIST](idList);
            }
            return [];
        };
    }
};
